export default __webpack_public_path__ + "images/SpeakersPhotos/ANA_SANTIAGO.jpg?bb317164";